import { B2BDealType, B2CDealType, CostDealType } from "@/app/constants";
import { IPricing } from "@/app/domain";

import { CalculationStrategy, PriceResult } from "../base/calculation.strategy";
import { ReactiveComponent } from "../../entities/base-component";
import { KompasDoubleGlazingPriceMultiplier } from "@/app/constants/multipicators";
import { isKompasDlb } from "@/app/predicates/systems.predicates";

export class HalfInstallationCalculationStrategy extends CalculationStrategy {
    calculate(component: ReactiveComponent, [priceWithDiscount, halfInstallationSum, overChargeSum, isOverchargeSelected, systemCode]): PriceResult {
        if (!priceWithDiscount) {
            return this.getDefaultResult();
        }

        return {
            price: this.calculatePriceWithOvercharge(
                priceWithDiscount, halfInstallationSum, overChargeSum, isOverchargeSelected,
                CostDealType,
                systemCode,
            ),
            priceB2C: this.calculatePriceWithOvercharge(
                priceWithDiscount, halfInstallationSum, overChargeSum, isOverchargeSelected,
                B2CDealType,
                systemCode,
            ),
            priceB2B: this.calculatePriceWithOvercharge(
                priceWithDiscount, halfInstallationSum, overChargeSum, isOverchargeSelected,
                B2BDealType,
                systemCode,
            ),
        };
    }

    private calculatePriceWithOvercharge(
        priceWithDiscount: IPricing,
        halfInstallationSum: number,
        overChargeSum: number,
        isOverchargeSelected: boolean,
        dealType: string,
        systemCode: string,
    ) {
        let finalPrice = 0;

        if (isOverchargeSelected) {
            const installationSum = priceWithDiscount.getSystemPrice(dealType).getValue() + overChargeSum;
            finalPrice = installationSum - halfInstallationSum;
        } else {
            finalPrice = priceWithDiscount.getSystemPrice(dealType).getValue() - halfInstallationSum;
        }
        return isKompasDlb(systemCode) ? finalPrice * KompasDoubleGlazingPriceMultiplier : finalPrice;
    }
}
